import { render } from "./ScrollThumbBlock.vue?vue&type=template&id=4b25f053&scoped=true"
import script from "./ScrollThumbBlock.vue?vue&type=script&lang=js"
export * from "./ScrollThumbBlock.vue?vue&type=script&lang=js"

import "./ScrollThumbBlock.vue?vue&type=style&index=0&id=4b25f053&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b25f053"]])

export default __exports__